import * as React from 'react';
const SvgRewardsOutline = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 14 13"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.333 3H10.88c.073-.207.12-.434.12-.667a1.997 1.997 0 0 0-3.667-1.1L7 1.68l-.334-.454A2.008 2.008 0 0 0 5 .333c-1.107 0-2 .893-2 2 0 .233.046.46.12.667H1.666C.926 3 .34 3.593.34 4.333l-.007 7.333c0 .74.593 1.334 1.333 1.334h10.667c.74 0 1.333-.594 1.333-1.334V4.333c0-.74-.593-1.333-1.333-1.333M9 1.666c.366 0 .666.3.666.667C9.666 2.7 9.366 3 9 3a.669.669 0 0 1-.667-.667c0-.367.3-.667.667-.667m-3.334.667c0-.367-.3-.667-.666-.667-.367 0-.667.3-.667.667 0 .367.3.667.667.667.366 0 .666-.3.666-.667m6.667 9.333H1.666v-1.333h10.667zM1.666 8.333h10.667v-4H8.946l1.387 1.887-1.08.78-1.587-2.16L7 3.933l-.667.907L4.746 7l-1.08-.78 1.387-1.887H1.666z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgRewardsOutline;
